export default {
    template: '#modal_mail_template',
    data() {
        return {
            ml_templ_name: '',
            ml_templ_email: '',
            ml_templ_subject: '',
            ml_templ_body: '',
        };
    },
    props: {
        modal_data: {
            type: Object,
            require: true
        },
        /**
         * テンプレート種別
         */
        kind: {
            type: String,
            require: true
        },
    },
    created: function () {
        this.setData();
    },
    mounted: function () {
        $('#modal_mail_' + this.kind).on('hidden.bs.modal', () => {
            // 未保存時は元データに戻す
            this.setData();
        });
    },
    emits: ['decided-mail-template'],
    methods: {
        setData: function() {
            this.ml_templ_name = this.modal_data.ml_templ_name;
            this.ml_templ_email = this.modal_data.ml_templ_email;
            this.ml_templ_subject = this.modal_data.ml_templ_subject;
            this.ml_templ_body = this.modal_data.ml_templ_body;
        },
        /**
         * 編集データを親に送る
         * 「登録する」ボタンを押さないと適応されない
         * 押さない場合はモーダル内の表記は編集されたままだが、保存はされてない
         */
        submit: function(event) {
            // HTML5のバリデーションエラーの場合はそのままフォーム送信する
            if (!event?.target?.form?.checkValidity()) {
                return;
            }
            event.preventDefault();

            this.$emit('decided-mail-template', {
                kind: this.kind,
                modal_data: {
                    ml_templ_name: this.ml_templ_name,
                    ml_templ_email: this.ml_templ_email,
                    ml_templ_subject: this.ml_templ_subject,
                    ml_templ_body: this.ml_templ_body,
                    no: this.modal_data.no,
                }
            });
            bootstrap.Modal.getOrCreateInstance($('#modal_mail_' + this.kind)[0]).hide();
        }
    }
};

